import React, { useEffect, useMemo, useState } from 'react';
import { Progress, Divider } from 'antd';


const ProgressBarADistribuir = () => {
    const [percent, setPercent] = useState()


    return (<>
        {percent ? <>
            <Progress percent={percent} showInfo={false} />
            <Divider>Text</Divider> </> : <> </>}

    </>)
}

export default ProgressBarADistribuir;